__turbopack_context__.v({
  "centered": "AppDescription-module-scss-module__CxiX2G__centered",
  "text": "AppDescription-module-scss-module__CxiX2G__text",
  "textLg": "AppDescription-module-scss-module__CxiX2G__textLg",
  "textMd": "AppDescription-module-scss-module__CxiX2G__textMd",
});
